'use client';
import React from 'react';
import PageTitle from '../Layouts/Default/PageTitle';
import Image from 'next/image';
import Link from 'next/link';
import { useAppDispatch } from '@/hooks/redux';
import { showModal } from '@/store/slices/modalSlice';
import { useTranslations } from 'next-intl';

function NotFound() {
  const translate = useTranslations('notfound');
  const dispatch = useAppDispatch();
  const openContactModal = () => {
    dispatch(
      showModal({
        modalKey: 'Contact',
      })
    );
  };

  return (
    <div className="flex flex-col ">
      <PageTitle
        title={translate('title')}
        description={translate('description')}
      />
      <div className="flex justify-center items-center mb-10 md:-mt-16 ">
        <ol className="flex flex-col gap-4 list-none h6 text-[17px] md:text-[20px] text-center text-gray-dark max-w-[872px]">
          <li>
            <Link
              href={'/'}
              className="font-bold text-primary-blue hover:text-primary-dark-blue"
            >
              {translate('returntohomepage')}
            </Link>{' '}
            {translate('returntohomepage_description')}
          </li>
          <li>
            <Link
              href={'/tools'}
              className="font-bold text-primary-blue hover:text-primary-dark-blue"
            >
              {translate('allpdftoolspage')}
            </Link>{' '}
            {translate('allpdftoolspage_description')}
          </li>
          <li>
            {translate('trouble')}{' '}
            <span
              onClick={openContactModal}
              className="cursor-pointer font-bold text-primary-blue hover:text-primary-dark-blue"
            >
              {translate('contactus')}
            </span>{' '}
            {translate('weareheretohelp')}
          </li>
        </ol>
      </div>
      <div className="w-full flex justify-center">
        <Image
          src={'/images/notfound/notfound.svg'}
          alt="404 not found"
          width={424}
          height={304}
          className="object-cover  w-[424px] h-[304px]"
        />
      </div>
    </div>
  );
}

export default NotFound;
